import "./Introduction.css"
import logo from "../assets/logo.jpg"
import { motion, useInView } from "framer-motion";
import { useEffect, useState } from "react";

const Introduction = ({ ref }) => {
    const isInView = useInView(ref, { once: true, margin: "-100px" });
    const [isMobile, setMobile] = useState(false);

    useEffect(() => {
        if (window.innerWidth <= 768) setMobile(true);
    }, []);

    return (
        <motion.div
            ref={ref}
            initial={{ opacity: 0, y: 30 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 1, ease: "easeOut" }}
            className="introduction-container"
        >
            <div className="introduction-inner">
                {/* SOL */}
                <motion.div
                    className="intro-left"
                    initial={{ opacity: 0, x: -30 }}
                    animate={isInView ? { opacity: 1, x: 0 } : {}}
                    transition={{ duration: 0.8, delay: 0.2 }}
                >
                    <span className="intro-eyebrow">Hakkımızda</span>
                    <h1 className="intro-title">Güçlükaya İnşaat</h1>
                    <div className="intro-accent-line" />
                    <p className="intro-text">
                        2023 yılında Ankara'da kurulan firmamız, 21 yıllık köklü bir tecrübenin eseridir.
                        Mühendislik disiplini ve teknik donanımı, iş etiğiyle harmanlayarak projelerimizi
                        uluslararası standartlarda tamamlıyoruz.
                    </p>
                </motion.div>

                {/* SAĞ - KART */}
                <motion.div
                    className="intro-card"
                    initial={{ opacity: 0, x: 30 }}
                    animate={isInView ? { opacity: 1, x: 0 } : {}}
                    transition={{ duration: 0.8, delay: 0.35 }}
                >
                    {/* Üst köşe dekoratif */}
                    <div className="intro-card-deco" />

                    <img src={logo} alt="Logo" className="intro-logo" style={{border: "1px solid rgba(255, 255, 255, 0.3)"}}/>

                    <p className="intro-quote">
                        "Deprem konut projeleri kapsamında Malatya Yeşilyurt'ta 404 konut,
                        114 dükkan ve 12 ofis projesinin ince imalatlarını büyük bir titizlikle tamamladık."
                    </p>

                    <div className="intro-card-footer">
                        <div className="intro-card-footer-line" />
                        <span>Güçlükaya İnşaat</span>
                    </div>
                </motion.div>
            </div>
        </motion.div>
    );
};

export default Introduction;